import { useTranslation } from 'react-i18next';
import * as Shared from '@shared/lib';

export function ChassisLevel({ xp }: { xp: number }) {
  const { t } = useTranslation(undefined, { keyPrefix: 'Arsenal.Chassis' });

  const level = Shared.ChassisLevelCalculator.calc(xp);
  const progress = Math.min(100, (xp - level.base) / level.toNext * 100);

  return (
    <div className="w-full h-4 relative bg-tertiary flex items-center p-0.5">
      <div className="bg-primary/40 h-full absolute inset-0" style={{ width: `${progress}%` }} />
      <p className="z-10 text-xs text-center w-full">
        {t('level')} {level.current}
      </p>
    </div>
  );
}